import React, { Component } from "react";
import { Grid, Avatar, Typography, Button, Hidden } from "@material-ui/core";
import { connect } from "react-redux";
import DishesListBox from "../DishesListBox";

import { webFont, textBlack, textGrey } from "../../config/theme";
import { client } from "../../config/apollo";
import { FEATURED_DISHES } from "../../graphql/queries/dishes";
import { setFeaturedChefs } from "../../redux/chefs";

const defaultChefImg = "/images/simple-chef.webp";

class FDishes extends Component {
  state = {
    featuredDishesList: []
  };

  componentDidMount() {
    client
      .query({
        query: FEATURED_DISHES,
        variables: {
          dishCount: 6
        }
      })
      .then(resp => {
        if (resp.data) {
          if (resp.data.featuredDishes) {
            this.setState({ featuredDishesList: resp.data.featuredDishes });
            setFeaturedChefs(resp.data.featuredDishes);
          }
        }
      })
      .catch(err => {
        console.error("Featured dishes: ", err);
      });
  }

  handleClick = dish => {
    const { history } = this.props;
    history.push("/home/dish-details", { dishId: dish.id });
  };

  render() {
    const { featuredDishesList } = this.state;

    let fChefs = null;
    if (featuredDishesList.length > 0) {
      fChefs = featuredDishesList.map(dish => {
        return (
          <React.Fragment>
            <DishesListBox
              dishImage={dish.media && dish.media.length ? dish.media[0].url : defaultChefImg}
              dishHeading={dish.name}
              dishDetail={(dish.cuisines && dish.cuisines.length>0) ? dish.cuisines.toString() : "No Cuisine"}
              dish={dish}
              dishChef={dish.chefName}
              handleClick={this.handleClick}
            />
            {/* <Hidden smDown>
              <Grid  data-test-id={"featdish-list"}
                container
                xs={12}
                sm={6}
                md={4}
                lg={4}
                key={dish.id}
                style={style.featuredItem}
                alignItems="center" justify="center"

              >
                <Grid item wrap='wrap'>
                  <Avatar
                    onClick={() => this.handleClick(dish)}
                    src={
                      dish.media && dish.media.length
                        ? dish.media[0].url
                        : defaultChefImg
                    }
                    alt="Image not available"
                    style={style.avatarImg}
                  />
                  <Grid item xs={12}  onClick={() => this.handleClick(dish)}>
                    <Hidden only={["md", "sm"]}>
                      <Typography
                        align="left"
                        variant="h6"
                        style={style.chefName}
                        gutterBottom={true}
                      >
                        {dish.name}
                      </Typography>
                    </Hidden>
                    <Hidden only={["xs", "lg", "xl"]}>
                      <Typography
                        align="left"
                        variant="h6"
                        style={style.chefNameTab}
                        gutterBottom={true}
                      >
                        {dish.name}
                      </Typography>
                    </Hidden>
                  </Grid>
                  <Grid item xs={12}  onClick={() => this.handleClick(dish)}>
                    <Hidden only={["md", "sm"]}>
                      <Grid>
                        <Typography
                          align="left"
                          variant="body1"
                          style={style.chefCuisine}
                          gutterBottom={true}
                          noWrap={true}
                        >
                          {(dish.cuisines && dish.cuisines.length>0) ? dish.cuisines.toString() : "No Cuisine"}
                        </Typography>
                      </Grid>
                      <Typography
                        align="left"
                        variant="subtitle1"
                        style={style.dishChefName}
                        gutterBottom={true}
                        noWrap={true}
                      >
                        {dish.chefName ? `Offered by: ${dish.chefName}` : ''}
                      </Typography>
                    </Hidden>
                    <Hidden only={["xs", "lg", "xl"]}>
                      <Grid>
                        <Typography
                          align="left"
                          variant="body1"
                          style={style.chefCuisineTab}
                          gutterBottom={true}
                          noWrap={true}
                        >
                          {(dish.cuisines && dish.cuisines.length>0)  ? dish.cuisines.toString() : "No Cuisine"}
                        </Typography>
                      </Grid>
                      <Typography
                        align="left"
                        variant="subtitle1"
                        style={style.dishChefName}
                        gutterBottom={true}
                        noWrap={true}
                      >
                        {dish.chefName ? `Offered by: ${dish.chefName}` : ''}
                      </Typography>
                    </Hidden>
                  </Grid>
                </Grid>
              </Grid>
            </Hidden> */}
            {/* <Hidden mdUp>
              <Grid  data-test-id={"featdish-list"}
                 container
                 xs={12}
                 sm={6}
                 md={4}
                 lg={4}
                 key={dish.id}
                 style={style.featuredItem}
                 alignItems="center" justify="center"
              >
                <Grid item wrap='wrap'>
                <Avatar
                  onClick={() => this.handleClick(dish)}
                  src={
                    dish.media && dish.media.length
                      ? dish.media[0].url
                      : defaultChefImg
                  }
                  alt="Image not available"
                  style={style.avatarImgIPad}
                />
                <Grid item xs={12}  onClick={() => this.handleClick(dish)}>
                  <Hidden only={["md", "sm"]}>
                    <Typography
                      align="left"
                      variant="h6"
                      style={style.chefName}
                      gutterBottom={true}
                    >
                      {dish.name}
                    </Typography>
                  </Hidden>
                  <Hidden only={["xs", "lg", "xl"]}>
                    <Typography
                      align="left"
                      variant="h6"
                      style={style.chefNameTab}
                      gutterBottom={true}
                    >
                      {dish.name}
                    </Typography>
                  </Hidden>
                </Grid>
                <Grid item xs={12}  onClick={() => this.handleClick(dish)}>
                  <Hidden only={["md", "sm"]}>
                    <Grid>
                      <Typography
                        align="left"
                        variant="body1"
                        style={style.chefCuisine}
                        gutterBottom={true}
                        noWrap={true}
                      >
                        {(dish.cuisines && dish.cuisines.length>0) ? dish.cuisines.toString() : "No Cuisine"}
                      </Typography>
                    </Grid>
                    <Typography
                      align="left"
                      variant="subtitle1"
                      style={style.dishChefName}
                      gutterBottom={true}
                      noWrap={true}
                    >
                      {dish.chefName ? `Offered by: ${dish.chefName}` : ''}
                    </Typography>
                  </Hidden>
                  <Hidden only={["xs", "lg", "xl"]}>
                    <Grid>
                      <Typography
                        align="left"
                        variant="body1"
                        style={style.chefCuisineTab}
                        gutterBottom={true}
                        noWrap={true}
                      >
                        {(dish.cuisines && dish.cuisines.length>0)  ? dish.cuisines.toString() : "No Cuisine"}
                      </Typography>
                    </Grid>
                    <Typography
                      align="left"
                      variant="subtitle1"
                      style={style.dishChefName}
                      gutterBottom={true}
                      noWrap={true}
                    >
                      {dish.chefName ? `Offered by: ${dish.chefName}` : ''}
                    </Typography>
                  </Hidden>
                </Grid>
              </Grid>
              </Grid>
            </Hidden> */}
          </React.Fragment>
        );
      });
    }

    return (
      <Grid container className="saved-item-container" direction="row" style={style.ftGrid}>
        <Grid container alignItems="flex-start">
          <Grid item xs={3} md={4} lg={4} xl={5} style={{ borderBottom: '1px solid #000', marginTop: 47 }} />
          <Grid item xs={6} md={4} lg={4} xl={2} >
            <Typography variant="h5" style={style.ftText} align={"center"}>
              Featured dishes
            </Typography>
          </Grid>
          <Grid item xs={3} md={4} lg={4} xl={5} style={{ borderBottom: '1px solid #000', marginTop: 47 }}  />
        </Grid>
        <Grid className="dish-container" container alignItems={'center'}>
          <div className="dish-conatiner-row">
            {fChefs}
          </div>
        </Grid>
        <Grid container alignItems="center" justify="center">
          <Button
           data-test-id={"featdish-showall"}

            variant="contained"
            color="primary"
            onClick={() =>
              this.props.history.push("/home/dish-search", { search: "a" })
            }
            style={style.showBtn}
          >
            Show All
          </Button>
        </Grid>
      </Grid>
    );
  }
}

const mapStateToProps = state => {
  return {
    userId: state.auth.userId,
    featuredChefs: state.chefs.featuredChefs,
    isChef: state.auth.isChef
  };
};

const FeaturedDishes = connect(mapStateToProps)(FDishes);

export default FeaturedDishes;

const style = {
  avatarImg: {
    width: '97%',
    height: 210,
    borderRadius: 5
  },
  avatarImgIPad: {
    width: '97%',
    height: 210,
    borderRadius: 5
  },
  ftGrid: {
    marginTop: 40,
    marginBottom: 10,
  },
  ftText: {
    fontFamily: webFont,
    color: textBlack,
    fontWeight: 500,
    margin: '30px 0 30px 20px',
  },
  chefName: {
    fontFamily: webFont,
    color: textBlack,
    fontWeight: 500,
  },
  chefNameTab: {
    fontFamily: webFont,
    color: textBlack,
    fontWeight: 500,
  },
  chefCuisine: {
    fontFamily: webFont,
    color: textGrey,
    weight: 500,
    maxWidth: 400,
  },
  chefCuisineTab: {
    fontFamily: webFont,
    color: textGrey,
    weight: 500,
    maxWidth: 400,
  },
  featuredItem: {
    marginTop: 20,
    marginBottom: 10,
    alignItems:"center",
    justify:"center"
  },
  dishChefName: {
    fontFamily: webFont,
    color: textGrey,
    weight: 300,
    maxWidth: 300,
    fontSize: 12,
    marginTop: -5,
  },
  showBtn: {
    width: "220px",
    borderRadius: 40,
    paddingLeft: 20,
    paddingRight: 20,
    textTransform: "none",
    marginTop: 30,
    fontFamily: webFont,
    color: '#fff'
  }
};
